<template>
    <div class="blog-page app-page">
        <div v-show="!newPost">
            <div v-if="isAuthenticated" class="blog-page__post-btn">
                <v-btn dark color="#38B100" value="" @click="$refs.postEditorInstance.toggleWritePost()">Jauns raksts</v-btn>
            </div>
            <v-progress-circular
                    v-show="loadingPosts"
                    class="blog-page__loading"
                    :size="70"
                    :width="7"
                    color="green"
                    indeterminate
            ></v-progress-circular>
            <div v-show="!loadingPosts" class="blog-page__blog-posts">
                <v-layout row  wrap justify-center class="caterers__grid-layout-fix">

                    <BlogCard
                        v-for="document in documents"
                        v-bind:document="document"
                        v-bind:key="document.id">
                    </BlogCard>

                </v-layout>
            </div>
        </div>

        <PostEditor
            v-bind:author="username"
            ref="postEditorInstance"
            v-if="isAuthenticated"
            v-on:toggle-post="newPost = $event"
            v-on:post-submitted="getArticles">
        </PostEditor>

    </div>
</template>

<script>
    import BlogCard from '../components/BlogCard';
    import PostEditor from '../components/PostEditor';
    import firebaseCfg from "../firebaseConfig";

    import firebase from 'firebase/app'
//    require('firebase/auth');

    export default {
        name: "Blog",
        components: { BlogCard, PostEditor },
        data() {
            return {
                newPost: false,
                documents: [],
                username: '',
                isAuthenticated: false,
                loadingPosts: true,
            }
        },
        methods: {
            getArticles: function(){
                const that = this;
                const articles = [];

                firebaseCfg.db.collection("posts").orderBy("createDate", "desc").get().then(function(querySnapshot){
                    querySnapshot.forEach(function(doc){
                        let document = doc.data();

                        document.articleHref = "/zinas/"+doc.id;
                        articles.push(document);
                        that.documents = articles;
                        
                        that.loadingPosts = false;
                    })
                });
            }
        },
        mounted() {
            const that = this;

            that.getArticles();

            firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                    that.username = user.email;
                    that.isAuthenticated = true;
                } else {
                    that.isAuthenticated = false;
                }
            });
        }
    }
</script>
<style>
    .blog-post__embed-container {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;
    }
    .blog-post__embed-video-resizer {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .blog-post__img-centering {
        display: block;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
</style>
<style scoped>
    .blog-page{
        padding-top: 120px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-decoration: none;
        max-width: 1370px;
        margin: 0 auto;
    }
    .caterers__grid-layout-fix {
        display: grid;
        grid-template-columns: repeat(auto-fit, 330px);
        grid-column-gap: 20px;
        grid-row-gap: 35px;
    }
    .blog-page__loading {
        display: flex;
        margin: 0 auto;
    }
    .blog-page__blog-posts { margin-bottom: 25px; }
    .blog-page__editor-placeholder {
        max-width: 900px;
        margin: 0 auto;
        justify-content: center;
        display: flex;
        flex-direction: column;
    }
    .blog-page__post-btn {
        margin: 25px 0;
        display: flex;
        justify-content: center;
    }
</style>